export * from './mostrar-tutorial/mostrar-tutorial.component';
export * from './mostrar-tutorial/mostrar-tutorial.module'; 